import { NavBar } from 'components/NavBar/NavBar'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Flex,
  H1WithBack,
  PageWrapper,
  TabFooter,
  Button,
  PageFooter,
} from 'styling/GlobalStyles'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from 'store'
import { IRoleTemplate } from 'types/roles.interface'
import { toast } from 'react-toastify'
import { addRoleTemplate } from 'features/roles/roleTemplatesSlice'
import { Input } from 'components/Input/Input'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { CancelBtn } from 'components/Button/CancelBtn'

export const AddRoleTemplate = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const [state, setState] = useState<IRoleTemplate>({
    name: '',
    permissionPolicy: null,
  })

  const handleSubmit = async () => {
    if (state.name.length < 1) {
      toast.warn('Role template name must be filled')
      return
    }

    const resp = await dispatch(addRoleTemplate(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/resources-role-templates')
    }
  }


  const parsePolicies = (data: any) => {
    return data.data.map((item: any) => ({ label: item.policyName, value: item.id }))
  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between main>
          <H1WithBack mb='1.5' arrow title='Add Role Template' />
        </Flex>
        <Flex gap='1rem' column width='300px' >
          <Input name='name' value={state.name} labelText='Name' nomarg placeholder='Enter name...' onChange={e => setState(prev => ({ ...prev, name: e.target.value }))} />
          <HonestSelectAsyncInput nomarg parserFunction={parsePolicies} defaultValue={state.permissionPolicy?.label} onChange={v => setState(prev => ({ ...prev, permissionPolicy: v }))} labelText='Permission Policy Template' link='permission-policy/role-template' name='permissionPolicy' />
        </Flex>

      </PageWrapper>
      <PageFooter>
        <Flex end='true' gap='1em'>
          <CancelBtn />
          <Button orange type='button' onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </PageFooter>
    </>
  )
}
